import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeroComponent } from './components/hero/hero.component';
import { AboutComponent } from './components/about/about.component';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { CounterComponent } from './components/counter/counter.component';
import { MarqueeComponent } from './components/marquee/marquee.component';
import { ServicesComponent } from './components/services/services.component';
import { ProductsComponent } from './components/products/products.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { AwardsComponent } from './components/awards/awards.component';
import { ScrollProgressComponent } from './components/scroll-progress/scroll-progress.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ViewalltemplateComponent } from './components/viewalltemplate/viewalltemplate.component';
import { HomeComponent } from './components/home/home.component';
import { TemplatePreviewComponent } from './components/template-preview/template-preview.component';
import { CartComponent } from './components/cart/cart.component';
import { DownloadModalComponent } from './components/download-modal/download-modal.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HeroComponent,
    AboutComponent,
    BenefitsComponent,
    PricingComponent,
    CounterComponent,
    MarqueeComponent,
    ServicesComponent,
    ProductsComponent,
    PortfolioComponent,
    TestimonialsComponent,
    AwardsComponent,
    ScrollProgressComponent,
    HeaderComponent,
    FooterComponent,
    ViewalltemplateComponent,
    HomeComponent,
    TemplatePreviewComponent,
    CartComponent,
    DownloadModalComponent,
    ThankYouComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

